// Un onglet ne suit la déconnexion d'un autre onglet que si elle concerne la
// personne qu'il AFFICHE.
//
// POURQUOI
// --------
// Le bouton « Se déconnecter » poste `SIGN_OUT` sur le canal maison
// `flowcut-auth` (AuthContext). Chaque autre onglet se déconnectait sans
// regarder qui il affichait : un propriétaire qui se déconnecte éjectait le
// client en pleine réservation, et un client qui se déconnecte fermait le
// tableau de bord du propriétaire. Spec du 2026-09-25 :
// `.superpowers/specs/2026-09-25-deconnexion-meme-personne-design.md`.
//
// POURQUOI L'IDENTITÉ AFFICHÉE ET PAS LE STOCKAGE
// -----------------------------------------------
// Une session client vit dans le `localStorage` partagé, que l'émetteur efface
// APRÈS avoir posté. Un onglet du même client pourrait lire un stockage déjà
// vide et rester affiché connecté : la reconnexion fantôme que ce canal doit
// empêcher.
//
// Ce module n'importe rien.

export function shouldFollowCrossTabSignOut(
  message: { userId?: string | null },
  shownUserId: string | null,
): boolean {
  // Ancien format, posté par un onglet resté sur la version d'avant pendant un
  // déploiement : on garde l'ancien comportement, le sens sûr côté sécurité.
  if (!("userId" in message)) return true;
  const { userId } = message;
  // L'émetteur n'affichait personne : il n'y a personne à déconnecter.
  if (!userId) return false;
  return userId === shownUserId;
}
